import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.goodsSystem

// 获取所有的商机项目
export function queryWarehouse(data) {
    return request({
        url: serviceName + `/warehouse/query_warehouse_byPage`,
        method: 'post',
        data: data
    })
}

// 根据采购单入库全部货物
export function storgeAllGoods(data) {
    return request({
        url: serviceName + `/purchase/storage_all_goods?id=`+data.id,
        method: 'get',
        data: data
    })
}

// 单个货物入库
export function storageGoodsInWarehouse(data) {
    return request({
        url: serviceName + `/warehouse/storage_goods_in_warehouse`,
        method: 'post',
        data: data
    })
}

// 查询出入库明细
export function queryOutInDetails(data) {
    return request({
        url: serviceName + `/warehouse/query_out_in_details`,
        method: 'post',
        data: data
    })
}

// 查询出入库明细
export function outGoodsFromWarehouse(data) {
    return request({
        url: serviceName + `/warehouse/out_goods_from_warehouse`,
        method: 'post',
        data: data
    })
}


// 查询入库单(行政)
export function queryInStoreList(data) {
    return request({
        url: serviceName + `/tb_in_store_list`,
        method: 'post',
        data: data
    })
}

// 查询出库单(行政)
export function queryOutStoreList(data) {
    return request({
        url: serviceName + `/tb_out_store_list`,
        method: 'post',
        data: data
    })
}
